//import { Injectable } from "@angular/core";
//import {
//    HttpRequest,
//    HttpHandler,
//    HttpInterceptor,
//} from "@angular/common/http";
//import { finalize } from "rxjs/operators";
//import { of } from "rxjs";
//import { HttpMonitorService } from "../services/http-monitor.service";

//@Injectable({
//    providedIn: "root",
//})
//export class NbcHttpInterceptor implements HttpInterceptor {
//    private totalRequests = 0;

//    constructor(private loadingService: HttpMonitorService) {}

//    intercept(request: HttpRequest<any>, next: HttpHandler) {
//        if (request.method !== "GET") {
//            this.totalRequests++;
//            this.loadingService.setLoading(true);
//            return next.handle(request).pipe(
//                finalize(() => {
//                    this.totalRequests--;
//                    if (this.totalRequests === 0) {
//                        this.loadingService.setLoading(false);
//                    }
//                })
//            );
//        } else return next.handle(request);
//    }
//}

import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpInterceptor } from "@angular/common/http";
import { finalize, tap } from "rxjs/operators";
import { of } from "rxjs";
import { HttpMonitorService } from "../services/http-monitor.service";

@Injectable({
    providedIn: "root",
})
export class CustomHttpInterceptorService implements HttpInterceptor {
    private totalRequests = 0;

    /** Suraj - Point to note: This is a pattern array NOT THE STRING array. */
    private excludePatterns: any = [/api\/ping$/];
    constructor(private loadingService: HttpMonitorService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        if (this.excludeUrlProcessing(request.url)) {
            return next.handle(request);
        }
        const trackTiming = request.headers.get("X-Track-Timing") === "true";

        //  if (request.method !== "GET") {
        const started = Date.now();

        this.totalRequests++;

         this.loadingService.setLoading(true);

        this.loadingService.setShowLoader(true);
        return next.handle(request).pipe(
            tap((event) => {
                if (event.type === 4 && trackTiming) {
                    // HttpResponse
                    const elapsed = Date.now() - started;
                    this.loadingService.logTime(request.url, elapsed);
                }
            }),
            finalize(() => {
                this.totalRequests--;
                //if (request.method !== "GET")

                if (this.totalRequests === 0) {
                    this.loadingService.setLoading(false);
                    this.loadingService.setShowLoader(false);
                }
            })
        );
        //} else return next.handle(request);
    }

    excludeUrlProcessing(url) {
        const urlMatches = this.excludePatterns.some((pattern) =>
            pattern.test(url)
        );
        return urlMatches || false;
    }
}
